"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PASSPHRASE_FLOW = void 0;
var PASSPHRASE_FLOW;
(function (PASSPHRASE_FLOW) {
    PASSPHRASE_FLOW["PASSPHRASE"] = "passphrase";
    PASSPHRASE_FLOW["SYMMETRIC_KEY"] = "symmetric_key";
})(PASSPHRASE_FLOW || (exports.PASSPHRASE_FLOW = PASSPHRASE_FLOW = {}));
